import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const ListContainer = styled.div`
  padding: 307px ${({ theme }) => theme.sz.pageSidePadding} 30px;
  ${media.desktop`
    padding: 307px ${({ theme }) => theme.sz.pageSidePaddingS} 20px;
  `}
`;

export const EmptyMessage = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 120px;

  .hl3 {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;
